import { createAxiosInstance } from './http';

export const getFaqs = async () => {
  const res = await createAxiosInstance().get('/faq');
  const data = res.data.data || res.data;
  return (Array.isArray(data) ? data : []).map((item) => ({
    ...item,
    id: item.id || item._id,
    _id: item._id || item.id,
  }));
};

